/**
 * @module views\mdl\dependedStructure
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { MethodService } from "@/utils/serviceModel";
import StructureNavigation from "@/businessComponents/mdl/structureNavigation/structureNavigation";
import StructureSelector from "@/businessComponents/mdl/structureSelector/structureSelector";
import { TreeNode } from "element-ui/types/tree";
import GhBase from "@/components/ghBase";

@Component({
  components: {
    StructureNavigation,
    StructureSelector
  }
})
export default class DependedStructure extends GhBase {
  protected tabs: IGhTab[] = [
    {
      title: "数据维护",
      drawer: true
    }
  ];

  /**
   * 查询参数
   */
  protected argsQuery: IndexObject = { structure_cd: "", keywords: "" };

  /**
   * 新增对象时的模板
   */
  protected itemTemplate: IndexObject = {};

  /**
   * 选中的model
   */
  protected selectedModels: IndexObject[] = [];

  /**
   * 选中的结构
   */
  protected selectedStructure: TreeNode<string, IndexObject> | null = null;

  /**
   * 根据struId获取统计结果
   * @param struId
   */
  protected getCount(struId) {
    let item = this.statisticCount[struId] as IndexObject;
    if (item) {
      return item.value;
    }
    return 0;
  }

  protected async changeStructureTo(node: TreeNode<string, IndexObject>) {
    if (this.selectedModels.length > 0) {
      let ids = this.selectedModels.map(x => x.Id);
      let posName = node.data.Name;
      try {
        this.$setLoading(true);
        await this.invokeChangeStructure(ids, node.key, posName);
      } catch (error) {
      } finally {
        this.$setLoading(false);
      }
      let sNv = this.$refs.struNav as StructureNavigation;
      if (sNv) {
        sNv.query();
      }
      this.query();
    }
  }

  /**
   * 按结构统计数量
   */
  protected async invokeStatisticCount() {
    try {
      let res = await this.svStatisticCount.invokeAsyn({});
      if (res.data.isSuccess) {
        this.statisticCount = res.data.data;
      } else {
        this.statisticCount = {};
      }
    } catch (error) {
      this.statisticCount = {};
    }
  }

  /**
   *
   * @param ids 改变结构
   * @param struId
   * @param struName
   */
  protected async invokeChangeStructure(ids, struId, struName = "") {
    let args = {
      ids,
      structure_id: struId,
      structure_name: struName
    };

    try {
      await this.svchangeStructure.invokeAsyn(args);
    } catch (error) {}
  }

  created() {
    if (this.module && this.cls) {
      this.svStatisticCount = this.$createService(
        this.module,
        this.cls,
        "statistic_stru_count"
      );
      this.svchangeStructure = this.$createService(
        this.module,
        this.cls,
        "change_structure"
      );
    }
  }

  /**
   * 选择的结构变化时
   */
  @Watch("selectedStructure")
  private observeSelectedStructure() {
    if (this.selectedStructure) {
      this.argsQuery.structure_cd = this.selectedStructure.data.Cd;
      this.itemTemplate[this.structureIdColumn] = this.selectedStructure.key;
      this.itemTemplate[
        this.structureNameColumn
      ] = this.selectedStructure.data.Name;
    }
  }

  @Watch("argsQuery", { deep: true })
  protected query() {
    let table = this.$refs[this.pageRef] as GhTablePage;
    if (table) {
      table.query(this.argsQuery);
    }
  }

  protected statisticCount: IndexObject = {};
  protected svStatisticCount: MethodService;

  protected svchangeStructure: MethodService;

  protected module = "";
  protected cls = "";

  protected structureIdColumn = "StructureId";
  protected structureNameColumn = "StructureName";
  protected pageRef = "table";
}
